import React from 'react'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Modal } from 'components/shared/Modal/Modal'

import { mapInternalStateToPayload } from './actions'
import { useFormState, useInternalState } from './hooks'
import {
  getActiveStep,
  getCancelButtonLabel,
  getConfirmButtonLabel,
  getCreateDefaultValues,
  getModalTitle,
} from './model'

import styles from './SavePositionTemplateModal.module.scss'

export const SavePositionTemplateModal = ({
  project,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const [formState, setFormState] = React.useState(getCreateDefaultValues())

  const data = React.useMemo(
    () => mapInternalStateToPayload({ ...project, ...formState }),
    [formState, project],
  )

  const { create } = useFormState(setFormState)

  const {
    activeStep,
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    isConfirmationOpen,
  } = useInternalState(
    { create, data, isOpen },
    { onCancel, onClose, onConfirm },
  )

  const step = getActiveStep({ create, step: activeStep })
  const cancelLabel = getCancelButtonLabel({ step: activeStep })
  const confirmLabel = getConfirmButtonLabel({ step: activeStep })
  const title = getModalTitle({ step: activeStep })

  return (
    <>
      <Modal
        className={styles.modal}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ cancelLabel, confirmLabel, title, isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>{step}</Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
